/**
 * Groups API - Per-conversation chat mute
 *
 * `POST /v1/groups/:group_id/chat-mute` mutes a conversation for the calling
 * member; `DELETE` unmutes it. The pair mirrors the archive route pair on the
 * same router.
 *
 * This is NOT the notification preference in `./preferences`. That one stores a
 * `notificationLevel` the chat push path never reads — writing it silenced the
 * member's TIMELINE and left chat pushing, which is the bug this endpoint
 * exists to end. Chat mute lives on the Stream channel member, is the flag the
 * push resolver honours, and moves nothing else: a muted conversation still
 * shows the group's posts in the member's timeline.
 *
 * The two controls are independent on purpose. A client that wants "silence
 * this conversation" calls this; a client that wants "stop following this group
 * in my timeline" calls follow/unfollow. Neither should be wired to the other.
 */

import { z } from 'zod'

// ============================================================================
// POST / DELETE /v1/groups/:group_id/chat-mute
// ============================================================================

export const ChatMuteResultSchema = z.object({
  groupId: z.string(),
  userId: z.string(),
  muted: z.boolean()
})

export type ChatMuteResult = z.infer<typeof ChatMuteResultSchema>

export const ChatMuteResponseSchema = z.object({
  message: z.string(),
  data: ChatMuteResultSchema
})

export type ChatMuteResponse = z.infer<typeof ChatMuteResponseSchema>
